import { render, staticRenderFns } from "./aspenridgeHomes.vue?vue&type=template&id=506dd3f5&"
import script from "./aspenridgeHomes.vue?vue&type=script&lang=js&"
export * from "./aspenridgeHomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports